<template>
    <div class="form-overlay select-product" :class="position">
        <div class="steep1" v-if="steep == 1">
            <p >{{ $t('dash.post-creator.overlay.select-product-instruction') }}</p>
            <div class="content" v-if="productsSelect.length">
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="false"></span>
                    <div class="item" v-for="product in productsSelect" :key="product.id">
                        <img :src="product.image ? product.image : 'img/avatar.jpg'" alt="">
                        <div class="info">
                            <p class="username">{{ product.text}}</p>
                            <!-- <p class="name">{{ product.name }}</p> -->
                        </div>
                        <i class="fa-regular fa-xmark" @click="removeProduct(product.id)"></i>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="steep2" v-else-if="steep == 2">
            <div class="content">
                <div class="containerInput">
                    <div class="input">
                        <i class="fa-regular fa-magnifying-glass"></i>
                        <input :placeholder="$t('dash.post-creator.overlay.search-shop')" v-model="textSearchShop" v-on:keyup.enter="sendSearchShops">
                    </div>
                </div>
              
                <p v-if="!textSearchShop.length" class="title">{{ $t('dash.post-creator.overlay.suggested-shops') }}</p>
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <template v-else-if="shops.length || !textSearchShop">
                        <div class="item" v-for="shop in (!textSearchShop ? shopsDefault : shops)" @click="selectShop(shop)" :key="shop.id">
                            <img :src="shop.image ? shop.image : 'img/avatar.jpg'" alt="">
                            <div class="info">
                                <p class="username">{{ shop.text }}</p>
                                <p class="name">{{ $t('dash.post-creator.overlay.shop-label') }}</p>
                            </div>
                        </div>

                    </template>
                    <p v-else class="no-result">{{ $t('dash.post-creator.overlay.no-shop') }}</p>
                </div>
            </div>
        </div>
        <div class="steep3" v-else-if="steep == 3">
            <div class="content">
                <div class="container-input">
                    <div class="back-btn" @click="steep = 2">
                        <i class="fa-solid fa-chevron-left"></i>
                    </div>
                    <div class="input">
                        <i class="fa-regular fa-magnifying-glass"></i>
                        <input :placeholder="$t('dash.post-creator.overlay.search-product')" v-model="textSearchProduct" v-on:keyup.enter="sendSearchProducts">
                    </div>
                </div>
                <p v-if="!textSearchProduct.length" class="title">{{ $t('dash.post-creator.overlay.suggested-products') }}</p>
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <template v-else-if="products.length || !textSearchProduct">
                        <div class="item" v-for="product in (!textSearchProduct ? productsDefault : products)" @click="selectProduct(product)" :key="product.id">
                            <img :src="product.image ? product.image : 'img/avatar.jpg'" alt="">
                            <div class="info">
                                <p class="username">{{ product.text }}</p>
                                <p class="name">{{ product.description }}</p>
                            </div>
                        </div>
                    </template>
                    <p v-else class="no-result">{{ $t('dash.post-creator.overlay.no-product') }}</p>
                </div>
            </div>
        </div>

         <div class="steep4" v-else-if="steep == 4">
            <div class="content">
                <p class="title">{{ $t('dash.post-creator.overlay.variant-choice') }}</p>
                <div class="list-item hide-scrollbar">
                    <span class="loader" v-if="stateLoader"></span>
                    <div class="item" v-else v-for="variant in variantsProduct" @click="selectVariant(variant)" :key="variant.id">
                        <img :src="variant.image ? variant.image : 'img/avatar.jpg'" alt="">
                        <div class="info">
                            <p class="username">{{ variant.number }}</p>
                            <!-- <p class="name">{{ variant.description }}</p> -->
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="btn-secondary" @click="$emit('close')">{{ $t('dash.button.close') }}</div>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    export default {
        props: {
            positionClick: {
                type: Object,
                default: undefined
            },
            productsSelect: {
                type: Array,
                default: ()=>[] 
            },
            position: {
                type: String,
                default: 'left'
            },
        },

        data() {
            return {
                steep : 1,
              
               
                lastIdEvent : 0,
                stateLoader : false,


                //shop
                textSearchShop : '',
                shopsDefault : [],
                shops : [],
                shopSelected: null,
                

                //product
                textSearchProduct : '',
                productsDefault : [],
                products: [],
                variantsProduct: [],
                productSelected: null,

                timeoutInitSearch : null,
            }
        },

        mounted() {
            EventBus.$on('resulttGetTrendShopFromSelectProduct', this.receveidTrendShops);
            EventBus.$on('resultSearchShopFromSelectProduct', this.receveidShops);
            EventBus.$on('resultGetTrendProductsFromSelectProduct', this.receveidTrendProducts);
            EventBus.$on('resultSearchProductFromSelectProduct', this.receveidProducts);
            EventBus.$on('resultGetVariantsProductFromSelectProduct', this.receveidVariantsProduct);

            EventBus.$emit("eventGetTrendShopsFromSelectProduct", this.lastIdEvent)
        },

        methods: {
            sendSearchShops() {
                if (!this.textSearchShop) return
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchShopsFromSelectProduct",this.textSearchShop,this.lastIdEvent)
            },

            sendSearchProducts() {
                if (!this.textSearchProduct || !this.shopSelected) return
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventSearchProductFromSelectProduct", this.shopSelected.id, this.textSearchProduct, this.lastIdEvent)
            },
            
            receveidTrendShops(shops,idEvent) {
                if ( this.lastIdEvent == idEvent) {
                    this.shopsDefault = shops
                    this.stateLoader = false
                }
            },

            receveidShops(shops,idEvent) {
                if ( this.lastIdEvent == idEvent) {
                    this.shops = shops || []
                    this.stateLoader = false
                }
            },

            receveidTrendProducts(products,idEvent) {
                this.productsDefault = products || []
                this.stateLoader = false
            },

            receveidProducts(products,idEvent) {
                if ( this.lastIdEvent == idEvent) {
                    this.products = products || []
                    this.stateLoader = false
                }
            },

            receveidVariantsProduct(variants,idEvent) {
                if ( this.lastIdEvent == idEvent) {
                    this.variantsProduct = variants
                    this.stateLoader = false
                    if ((!variants || !variants.length) && this.productSelected) {
                        console.log('selectProduct: no variant data returned, tagging product without variant', { productId: this.productSelected.id, shopId: this.shopSelected && this.shopSelected.id })
                        let product = this.productSelected
                        this.productSelected = null
                        EventBus.$emit("eventClickSelectProduct",{
                            shopId : this.shopSelected.id,
                            ...product,
                            ...this.positionClick,
                            timestamp : Date.now()
                        })
                        this.$emit("resetPositionClick")
                    }
                }
            },

            selectShop(shop) {
                this.shopSelected = shop
                this.textSearchProduct = ''
                this.steep = 3
                this.stateLoader = true
                this.lastIdEvent = new Date().getTime()
                EventBus.$emit("eventGetTrendProductsFromSelectProduct", shop.id ,this.lastIdEvent)
            },

            selectProduct(product) {

                if (product.variant == true) {
                    this.productSelected = product
                    EventBus.$emit("eventGetVariantsProductFromSelectProduct",product.id, this.shopSelected.id ,this.lastIdEvent)
                    this.steep = 4
                    this.stateLoader = true
                    return
                }else{
                    EventBus.$emit("eventClickSelectProduct",{
                        shopId : this.shopSelected.id,
                        ...product,
                        ...this.positionClick,
                        timestamp : Date.now()
                    })
                    this.$emit("resetPositionClick")    
                }
                
            },

            selectVariant(variant) {
                console.log("variant",variant)
                this.selectProduct({
                    ...this.productSelected,
                    image : variant.image ? variant.image : this.productSelected.image,
                    variant : variant,
                    id : variant.id,
                })
            },

            removeProduct(idProduct) {
                EventBus.$emit("eventRemoveSelectProduct",idProduct)
            }
        },

        watch: {
            textSearchShop(newValue, oldValue) {
                if (!this.textSearchShop) {
                    this.stateLoader = false
                    return
                }

                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchShops()
                },1000)
            },

            textSearchProduct(newValue, oldValue) {
                if (!this.textSearchProduct) {
                    this.stateLoader = false
                    return
                }

                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(() => {
                    this.sendSearchProducts()
                },1000)
            },

            positionClick(newValue, oldValue) {
                if (newValue) {
                    this.steep = 2
                }else{
                    this.steep = 1
                }
              
            }
        },

        beforeDestroy () {
            EventBus.$off('resulttGetTrendShopFromSelectProduct', this.receveidTrendShops);
            EventBus.$off('resultSearchShopFromSelectProduct', this.receveidShops);
            EventBus.$off('resultGetTrendProductsFromSelectProduct', this.receveidTrendProducts);
            EventBus.$off('resultSearchProductFromSelectProduct', this.receveidProducts);
            EventBus.$off('resultGetVariantsProductFromSelectProduct', this.receveidVariantsProduct);

         
        }
    }
</script>
    